import {IconButton, Stack, TableCell, TableRow, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Call02Icon, Clock01Icon, Delete02Icon} from "@hugeicons/core-free-icons";
import {CallStatusChip} from "../CallStatusChip";
import {ConversationLink} from "./ConversationLink";
import {canCallNumber, formatDateTime} from "../../utils";

const cellSx = {fontSize: 13, whiteSpace: "nowrap"};

const callDisabledReason = (row, maxAttempts) => {
  if (row.status === "ACTIVE") return "A call is in progress";
  if (row.status === "ANSWERED") return "Already answered";
  if ((row.attempts ?? 0) >= maxAttempts) return "Max attempts reached";
  return null;
};

export const CampaignPhoneNumberRow = ({row, maxAttempts, projectId, calling, onCall, onShowAttempts, onDelete}) => {
  const canCall = canCallNumber(row, maxAttempts) && !calling;
  const attemptsDone = (row.attempts ?? 0) >= maxAttempts;

  return (
    <TableRow hover>
      <TableCell sx={cellSx}>{row.phoneNumber}</TableCell>
      <TableCell><CallStatusChip status={row.status}/></TableCell>
      <TableCell sx={cellSx}>
        <Typography component="span" fontSize={13} fontWeight={attemptsDone ? 600 : 400}>
          {row.attempts ?? 0}
        </Typography>
        {` / ${maxAttempts}`}
      </TableCell>
      <TableCell sx={cellSx}>{formatDateTime(row.lastQueuedAt)}</TableCell>
      <TableCell sx={cellSx}>{row.lastCalledAt ? formatDateTime(row.lastCalledAt) : "Never"}</TableCell>
      <TableCell sx={cellSx}>
        <ConversationLink projectId={projectId} conversationId={row.lastConversationId}/>
      </TableCell>
      <TableCell sx={cellSx}>{formatDateTime(row.dateUpdated)}</TableCell>
      <TableCell padding="checkbox">
        <Stack direction="row">
          <Tooltip title={callDisabledReason(row, maxAttempts) || "Call now"}>
            <span>
              <IconButton size="small" color="success" disabled={!canCall} onClick={() => onCall(row)}>
                <HugeiconsIcon icon={Call02Icon} size={18}/>
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Call attempts">
            <IconButton size="small" onClick={() => onShowAttempts(row)}>
              <HugeiconsIcon icon={Clock01Icon} size={18}/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Remove from campaign">
            <IconButton size="small" onClick={() => onDelete(row)}>
              <HugeiconsIcon icon={Delete02Icon} size={18}/>
            </IconButton>
          </Tooltip>
        </Stack>
      </TableCell>
    </TableRow>
  )
}
